"use client";

import Link from "next/link";
import { LuCoins, LuTarget } from "react-icons/lu";

import { Button, buttonVariants } from "@/components/ui/button";
import {
  APP_ROUTES,
  FOCUS_TICKER_DISPLAY_NAME,
  FOCUS_TOKEN_DISPLAY_NAME,
} from "@/utils/constants";
import { cn } from "@/utils/lib";

export type ExtendedPrimaryCTAProps = {
  createWalletButtonSize?: "sm" | "xs";
  showBountyHunterLink?: boolean;
  showTradeFocusLink?: boolean;
  className?: string;
  innerWrapperClassName?: string;
  secondaryLinksClassName?: string;
  linkClassName?: string;
  createWalletLink?: string;
};

type PrimaryCTAProps = ExtendedPrimaryCTAProps & {
  onCreateWalletClick: (e: React.MouseEvent) => void;
  tradeLinkLabel?: string;
  primaryLinksClassName?: string;
  children?: React.ReactNode;
};

export const PrimaryCTA = ({
  showBountyHunterLink = true,
  showTradeFocusLink = true,
  onCreateWalletClick,
  tradeLinkLabel = "Trade",
  secondaryLinksClassName = "",
  primaryLinksClassName = "",
  innerWrapperClassName = "",
  linkClassName = "",
  createWalletButtonSize = "sm",
  children,
}: PrimaryCTAProps) => {
  return (
    <>
      {children}
      <div
        className={cn(
          "m-auto flex w-full flex-col flex-wrap items-center gap-4",
          innerWrapperClassName,
        )}
      >
        <div className={cn("w-full gap-4", primaryLinksClassName)}>
          <Link
            href={APP_ROUTES.signUp}
            prefetch={false}
            className={buttonVariants({
              variant: "default",
              size: createWalletButtonSize,
            })}
            onClick={onCreateWalletClick}
          >
            Create or Import Wallet
          </Link>
        </div>
        {(showTradeFocusLink || showBountyHunterLink) && (
          <div
            className={cn(
              "flex flex-wrap justify-center gap-4",
              secondaryLinksClassName,
            )}
          >
            {showBountyHunterLink && (
              <Link href="/bounty" prefetch={false}>
                <Button
                  variant="outline"
                  size={"sm"}
                  as="div"
                  className={cn("flex items-center gap-2", linkClassName)}
                >
                  <LuTarget className="text-primary" />
                  Bounty Hunter
                </Button>
              </Link>
            )}
            {showTradeFocusLink && (
              <Link
                href={`${process.env.NEXT_PUBLIC_OPENFUND_URI}/trade/${FOCUS_TOKEN_DISPLAY_NAME}`}
                target="_blank"
              >
                <Button
                  variant="outline"
                  size="sm"
                  as="div"
                  className={cn("flex items-center gap-2", linkClassName)}
                >
                  <LuCoins className="text-muted" />
                  {tradeLinkLabel} {FOCUS_TICKER_DISPLAY_NAME}
                </Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </>
  );
};
